import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'
import { bufferedTimeMs } from '../timeBuffer'

const LONG_START_WINDOW_MS = bufferedTimeMs(8000)
const LONG_START_MIN_LENGTH = 8

export const longStartCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  return (
    isAcceptedWordEntry(entry) &&
    entry.atMs <= LONG_START_WINDOW_MS &&
    entry.word.length >= LONG_START_MIN_LENGTH
  )
}
